/**
 * ลิงก์ไปหน้าอุปกรณ์ / ซิม — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลในหน้ารายการ `?view=<id>`)
 *   /master-data/devices            รายการ
 *   /master-data/devices/:id        รายละเอียด (devices.view)
 *   /master-data/devices/:id/edit   แก้ไข (devices.view + devices.edit)
 *   /master-data/devices/new        เพิ่มใหม่ (devices.create)
 *   (ซิมแบบเดียวกันที่ /master-data/sims · sims.*)
 *
 * ทุกที่ที่ลิงก์ไปอุปกรณ์/ซิมใช้ helper นี้ (URL contract อยู่ที่เดียว แบบ companyLinks/siteLinks)
 * ลิงก์เก่า `?view=<id>` ยังเปิดได้ — App.tsx ครอบหน้ารายการด้วย LegacyDetailRedirect
 */
export const DEVICES_PATH = '/master-data/devices';
export const SIMS_PATH = '/master-data/sims';
export const DEVICE_NEW_PATH = `${DEVICES_PATH}/new`;
export const SIM_NEW_PATH = `${SIMS_PATH}/new`;

const validId = (id: number | string | null | undefined): number | null => {
  const n = Number(id);
  return Number.isInteger(n) && n > 0 ? n : null;
};

/** หน้ารายละเอียดอุปกรณ์ — id ไม่ถูกต้อง = หน้ารายการ */
export function deviceDetailUrl(deviceId: number | string | null | undefined): string {
  const n = validId(deviceId);
  return n ? `${DEVICES_PATH}/${n}` : DEVICES_PATH;
}

export function deviceEditUrl(deviceId: number | string | null | undefined): string {
  const n = validId(deviceId);
  return n ? `${DEVICES_PATH}/${n}/edit` : DEVICES_PATH;
}

/** หน้ารายละเอียดซิม — id ไม่ถูกต้อง = หน้ารายการ */
export function simDetailUrl(simId: number | string | null | undefined): string {
  const n = validId(simId);
  return n ? `${SIMS_PATH}/${n}` : SIMS_PATH;
}

export function simEditUrl(simId: number | string | null | undefined): string {
  const n = validId(simId);
  return n ? `${SIMS_PATH}/${n}/edit` : SIMS_PATH;
}
